export default (function(doc, win) {
  const docEl = doc.documentElement;
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  const reCalc = function() {
    docEl.dataset.dpr = win.devicePixelRatio;
    const width = docEl.clientWidth;
    // 20，px : rem = 20 : 1
    docEl.style.fontSize = `${20 * (width / 750)}px`;
  };
  reCalc();
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, reCalc, false);
})(window.document, window);
